import { AxiosError } from 'axios';
import { GET_ANNOUNCEMENT_EXAM_CENTRES_URL } from 'web-library/constants/apiUrls';
import { GET_ANNOUNCEMENT_EXAM_CENTRES_QUERY_KEY } from 'web-library/constants/queryKeys';
import axiosClient from '../axiosClient';
import { ConfigurationType } from '../../api/candidate/config/model';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: ConfigurationType[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled: boolean;
}

export const useGetAnnouncementExamCentres = ({ onSuccess, onError, enabled }: Input) => {
  const getAnnouncementExamCentres = async () => {
    const res = await axiosClient.get<ConfigurationType[]>(GET_ANNOUNCEMENT_EXAM_CENTRES_URL);
    return res.data;
  };

  return useCustomQuery(GET_ANNOUNCEMENT_EXAM_CENTRES_QUERY_KEY, getAnnouncementExamCentres, {
    onSuccess,
    onError,
    enabled,
  });
};
